export default "__VITE_ASSET__wxesJ3Qn__"